export enum MealEnum {
  "صبحانه" = 1,
  "ناهار" = 2,
  "عصرانه" = 3,
  "شام" = 4,
}

export enum DeliveryEnum {
  "هیچکدام" = 1,
  "تک پرس" = 2,
  "قابلمه" = 3,
  "باکس" = 4,
  "آشپزی" = 5,
}

export enum ClearEnum {
  "قبل از مراسم" = 1,
  "با هماهنگی" = 2,
  "در محل" = 3,
}

export enum DeliveryEnumEng {
  nothing = 1,
  single = 2,
  pot= 3,
  box = 4,
  cooking = 5,
}
